import { defineMessages } from 'react-intl';

export default defineMessages({
    auditTitle: {
        id: 'ri.audit.views.usermanager.title.Audits',
        defaultMessage: 'Audits'
    },
    auditPayrollForm: {
        id: 'ri.gateway.auditStatements.Payroll Form',
        defaultMessage: 'Payroll Form'
    },
    auditPolicyNo: {
        id: 'ri.gateway.auditStatements.Policy #',
        defaultMessage: 'Policy #'
    },
    auditReportingPeriod: {
        id: 'ri.gateway.auditStatements.Reporting Period',
        defaultMessage: 'Reporting Period'
    },
    auditDueDate: {
        id: 'ri.gateway.auditStatements.Due Date',
        defaultMessage: 'Due Date'
    },
    auditReceivedDate: {
        id: 'ri.gateway.auditStatements.Received Date',
        defaultMessage: 'Received Date'
    },
    auditProcessedDate: {
        id: 'ri.gateway.auditStatements.Processed Date',
        defaultMessage: 'Processed Date'
    },
    auditStatus: {
        id: 'ri.gateway.auditStatements.Audit Status',
        defaultMessage: 'Audit Status'
    },
    auditType: {
        id: 'ri.gateway.auditStatements.Audit Type',
        defaultMessage: 'Audit Type'
    },
    auditchangeInPremium: {
        id: 'ri.gateway.auditStatements.Change In Premium',
        defaultMessage: 'Change In Premium'
    },
    auditTotleCost: {
        id: 'ri.gateway.auditStatements.Total Cost',
        defaultMessage: 'Total Cost'
    },
    auditStatemen :{
        id: "ri.gateway.auditStatements.Audit Statement",
        defaultMessage: "Audit Statement"
    },
    noAuditFound :{
        id: "ri.gateway.BillingDelivery.No audits are available to view for this policy period",
        defaultMessage: "No audits are available to view for this policy period"
    }
});